angular.module('rjmNg.directives').directive "saveSuccessNotification", [
  "$interval"
  ($interval) ->
    restrict: "E"
    templateUrl: "directive.saveSuccessNotification.html"
    replace: true
    scope:
      timestamp: "="
      showDuration: "="
      dashboard: "="
      gotoDashboardCallback: "="
      figureIsUnused: "="
    controller: [
      "$scope",
      "$interval",
      ($scope, $interval) ->

        $scope.gotoDashboard = () ->
          if $scope.gotoDashboardCallback
            $scope.gotoDashboardCallback($scope.dashboard.id)

      ]
    link: (scope, elem, attrs) ->
      timeoutId = $interval () ->
        if scope.timestamp
          currentDate = new Date()
          currentTimestamp = currentDate.getTime()
          if currentTimestamp - scope.timestamp >= scope.showDuration
            scope.timestamp = null
      , 100 # Granularity of 100ms

      elem.on '$destroy', () ->
        $interval.cancel(timeoutId)

]
